import React, { useState } from 'react';

const emptyForm = { name: '', email: '', phone: '', subject: '', message: '', website: '' };

// Ana sayfadaki (#home-form) ve /contact sayfasindaki form ayni bilesen.
// Gonderim public/api/send.php'ye gidiyor.
const ContactForm = () => {
    const [form, setForm] = useState(emptyForm);
    const [formStatus, setFormStatus] = useState('idle');
    const [formFeedback, setFormFeedback] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});

    // Basariyla gonderildikten sonra form kilitlenir; tekrar gonderilemez.
    const isFormLocked = formStatus === 'sending' || formStatus === 'success';

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        if (isFormLocked) return;

        setFormStatus('sending');
        setFormFeedback('');
        setFieldErrors({});

        try {
            const response = await fetch('/api/send.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form),
            });

            let data = {};
            try {
                data = await response.json();
            } catch {
                data = {};
            }

            if (response.ok && data.ok) {
                setForm(emptyForm);
                setFormStatus('success');
                setFormFeedback(data.message || 'Thanks! Your message has been sent.');
                return;
            }

            setFieldErrors(data.fields || {});
            setFormStatus('error');
            setFormFeedback(data.error || 'Something went wrong. Please try again later.');
        } catch {
            setFormStatus('error');
            setFormFeedback('Connection error. Please check your network and try again.');
        }
    };

    if (formStatus === 'success') {
        return (
            <div className={'p-4 rounded-3'} role="status" aria-live="polite"
                 style={{
                     border: '1px solid rgba(255, 255, 255, 0.15)',
                     background: 'rgba(255, 255, 255, 0.05)'
                 }}>
                <i className="bi bi-check-circle glowork-pink-color" style={{fontSize: '2rem'}}></i>
                <p className={'text-white fw-light mt-3 mb-0'} style={{fontSize: '1rem'}}>
                    {formFeedback}
                </p>
                <p className={'text-white fw-light mt-2 mb-0'} style={{fontSize: '0.9rem', opacity: 0.7}}>
                    We'll get back to you shortly.
                </p>
            </div>
        );
    }

    return (
        <form onSubmit={handleFormSubmit} noValidate>
            <div className={'row g-3 mb-3'}>
                <div className={'col-12 col-md-6'}>
                    <input type="text" name="name" value={form.name}
                           onChange={handleFormChange} disabled={isFormLocked}
                           className={'form-control custom-dark-input'}
                           placeholder="Your name"/>
                    {fieldErrors.name && (
                        <small className={'d-block mt-1 glowork-pink-color'}>{fieldErrors.name}</small>
                    )}
                </div>
                <div className={'col-12 col-md-6'}>
                    <input type="email" name="email" value={form.email}
                           onChange={handleFormChange} disabled={isFormLocked}
                           className={'form-control custom-dark-input'}
                           placeholder="E-mail"/>
                    {fieldErrors.email && (
                        <small className={'d-block mt-1 glowork-pink-color'}>{fieldErrors.email}</small>
                    )}
                </div>
            </div>

            <div className={'row g-3 mb-3'}>
                <div className={'col-12 col-md-6'}>
                    <input type="tel" name="phone" value={form.phone}
                           onChange={handleFormChange} disabled={isFormLocked}
                           className={'form-control custom-dark-input'}
                           placeholder="Phone"/>
                </div>
                <div className={'col-12 col-md-6'}>
                    <input type="text" name="subject" value={form.subject}
                           onChange={handleFormChange} disabled={isFormLocked}
                           className={'form-control custom-dark-input'}
                           placeholder="Subject"/>
                </div>
            </div>

            <div className={'mb-4'}>
                <textarea className={'form-control custom-dark-input'} rows="4"
                          name="message" value={form.message}
                          onChange={handleFormChange} disabled={isFormLocked}
                          placeholder="Message"></textarea>
                {fieldErrors.message && (
                    <small className={'d-block mt-1 glowork-pink-color'}>{fieldErrors.message}</small>
                )}
            </div>

            <input type="text" name="website" value={form.website}
                   onChange={handleFormChange} tabIndex="-1" autoComplete="off"
                   aria-hidden="true"
                   style={{position: 'absolute', left: '-9999px', opacity: 0, height: 0}}/>

            <div className={'d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-3'}>
                <div aria-live="polite" className={'small mb-0'}>
                    {formStatus === 'error' && (
                        <span className={'glowork-pink-color'}>
                            <i className="bi bi-exclamation-circle me-2"></i>{formFeedback}
                        </span>
                    )}
                </div>

                <button type="submit" disabled={isFormLocked}
                        className={'btn btn-send px-4 d-inline-flex align-items-center justify-content-center'}>
                    {formStatus === 'sending' ? 'SENDING...' : 'SEND'}
                    <i className="bi bi-arrow-up-right btn-icon text-white ms-2"></i>
                </button>
            </div>
        </form>
    );
};

export default ContactForm;
